<template>
  <div class="nav nav-tabs" id="orderTab" role="tablist">
    <div class="nav-item" role="presentation">
      <button class="nav-link" :class="{'active': selectedView==='object'}" id="object-tab" @click.prevent="$emit('click', 'object')" type="button" role="tab">Object</button>
    </div>
    <div class="nav-item" role="presentation">
      <button class="nav-link" :class="{'active': selectedView==='xml'}" id="xml-tab" @click.prevent="$emit('click', 'xml')" type="button" role="tab">XML</button>
    </div>
    <div class="nav-item" role="presentation">
      <button class="nav-link" :class="{'active': selectedView==='json'}" id="json-tab" @click.prevent="$emit('click', 'json')" type="button" role="tab">JSON</button>
    </div>
    <div class="nav-item" role="presentation">
      <button class="nav-link" :class="{'active': selectedView==='response'}" id="response-tab" @click.prevent="$emit('click', 'response')" type="button" role="tab">Response</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderBevestigingDetailTab',
  props: {
    selectedView: {
      type: String,
      default: 'object'
    }
  },
  emits: ['click']
}
</script>

<style scoped>
button {
  cursor: pointer;
}
</style>
